(() => {
  const copyButtons = document.querySelectorAll("[data-tbip-copy]");

  const copyWithFallback = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return true;
    }

    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "-9999px";
    textarea.style.opacity = "0";

    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    let copied = false;

    try {
      copied = document.execCommand("copy");
    } finally {
      document.body.removeChild(textarea);
    }

    return copied;
  };

  const showCopiedState = (button, label) => {
    const originalText = button.textContent;

    button.textContent = label;
    button.setAttribute("data-tbip-copied", "true");

    window.setTimeout(() => {
      button.textContent = originalText;
      button.removeAttribute("data-tbip-copied");
    }, 1800);
  };

  copyButtons.forEach((button) => {
    button.addEventListener("click", async () => {
      const value = button.getAttribute("data-tbip-copy");

      if (!value) {
        return;
      }

      const successText =
        button.getAttribute("data-tbip-copy-success") || "Copied";

      try {
        const copied = await copyWithFallback(value);

        if (copied) {
          showCopiedState(button, successText);
          return;
        }
      } catch (error) {
        // Fall through to the manual prompt below.
      }

      window.prompt("Copy this value", value);
    });
  });
})();
